import { Typography, Chip } from "@mui/material";
import { Celebration, TrendingUp, Whatshot, Favorite } from "@mui/icons-material";

const SubscriberStatusBadge = ({ children, variant = "subtitle2", ...props }) => {
  const text = typeof children === 'string' ? children : '';
  const isNewOnStanza = text === "New on Stanza";
  const isOnTheRise = text === "On the Rise";
  const isBuildingBuzz = text === "Building Buzz";
  const isFanFavorite = text === "Fan Favorite";
  
  // Don't render badge if it's not one of our special status messages
  const isSpecialStatus = isNewOnStanza || isOnTheRise || isBuildingBuzz || isFanFavorite;
  if (!isSpecialStatus) {
    return <Typography variant={variant} color="text.secondary" {...props}>{children}</Typography>;
  }

  const AnimatedIcon = ({ children: iconChildren }) => {
    let animationClass = 'pulse-animation';
    if (isNewOnStanza) animationClass = 'bounce-animation';
    else if (isBuildingBuzz) animationClass = 'shake-animation';
    else if (isFanFavorite) animationClass = 'heartbeat-animation';
    
    return (
      <>
        <style>
          {`
            @keyframes bounce {
              0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
              40% { transform: translateY(-2px); }
              60% { transform: translateY(-1px); }
            }
            @keyframes pulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.1); }
              100% { transform: scale(1); }
            }
            @keyframes shake {
              0%, 100% { transform: translateX(0); }
              25% { transform: translateX(-1px) rotate(-2deg); }
              75% { transform: translateX(1px) rotate(2deg); }
            }
            @keyframes heartbeat {
              0%, 50%, 100% { transform: scale(1); }
              25%, 75% { transform: scale(1.2); }
            }
            .bounce-animation {
              animation: bounce 2s infinite;
            }
            .pulse-animation {
              animation: pulse 2s infinite;
            }
            .shake-animation {
              animation: shake 1.5s infinite;
            }
            .heartbeat-animation {
              animation: heartbeat 1.8s infinite;
            }
          `}
        </style>
        <span
          className={animationClass}
          style={{ display: 'inline-flex' }}
        >
          {iconChildren}
        </span>
      </>
    );
  };

  return (
    <Chip
      icon={
        <AnimatedIcon>
          {isNewOnStanza && <Celebration sx={{ fontSize: '14px', ml: 0.5 }} />}
          {isOnTheRise && <TrendingUp sx={{ fontSize: '14px', ml: 0.5 }} />}
          {isBuildingBuzz && <Whatshot sx={{ fontSize: '14px', ml: 0.5 }} />}
          {isFanFavorite && <Favorite sx={{ fontSize: '14px', ml: 0.5 }} />}
        </AnimatedIcon>
      }
      label={text}
      color="default"
      variant="outlined"
      sx={{
        '& .MuiChip-label': {
          fontSize: '13px',
          ml: -0.5
        },
      }}
      {...props}
    />
  );
};

export default SubscriberStatusBadge;